// Shared by the block-based PDP and the 3D product section. Build zoom slides
// from the visible gallery so editor settings and variant swaps keep their order.
window.buildPdpGalleryModal = function (gallery, modalRoot) {
  var wrapper = modalRoot && modalRoot.querySelector('.modal-swiper-container .swiper-wrapper');
  var slides = gallery && gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
  if (!wrapper || !slides || !slides.length) return false;
  var fragment = document.createDocumentFragment();
  slides.forEach(function (slide) {
    var media = slide.querySelector('video, img');
    if (!media) return;
    var clone = media.cloneNode(true);
    clone.removeAttribute('class');
    clone.removeAttribute('style');
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    if (clone.tagName === 'VIDEO') {
      clone.removeAttribute('autoplay');
      clone.muted = true;
      clone.defaultMuted = true;
      clone.setAttribute('muted', '');
      clone.setAttribute('controls', '');
    } else {
      clone.src = (media.currentSrc || media.src).replace(/([?&])width=\d+/, '$1width=1946');
      clone.removeAttribute('srcset');
      clone.removeAttribute('sizes');
      clone.loading = 'lazy';
    }
    var item = document.createElement('div');
    item.className = 'swiper-slide';
    item.appendChild(clone);
    fragment.appendChild(item);
  });
  if (!fragment.childNodes.length) return false;
  wrapper.replaceChildren(fragment);
  return true;
};

// Keep the base 3D installation media when a preconfigured product supplies the
// main photos. Both the rail and slider are updated before their initialization.
window.appendPdpSupportingMedia = function (gallery, templates, options) {
  var root = gallery.closest('[data-pdp-images]');
  var wrapper = gallery.querySelector('.swiper-wrapper');
  var firstThumb = root && root.querySelector('.gallery-thumb');
  if (!wrapper || !firstThumb) return;
  var rail = firstThumb.parentElement;
  function mediaKey(slide) {
    var video = slide.querySelector('video');
    var image = slide.querySelector('img');
    var source = video && video.querySelector('source');
    var src = video ? (source && source.src) || video.src : image && image.src;
    return src ? new URL(src, document.baseURI).pathname : '';
  }
  var seen = new Set(Array.from(wrapper.children).map(mediaKey));
  templates.forEach(function (template) {
    var video = template.querySelector('video');
    if (!video && ((options && options.skipSupportingMedia) || root.dataset.pdpSupportingImages === 'false')) return;
    var key = mediaKey(template);
    if (!key || seen.has(key)) return;
    seen.add(key);
    var index = wrapper.children.length;
    var slide = template.cloneNode(true);
    slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
    slide.removeAttribute('style');
    slide.removeAttribute('data-variant-slide');
    slide.dataset.index = String(index);
    slide.dataset.pdpSupportingMedia = 'true';
    slide.querySelectorAll('video').forEach(function (item) {
      item.removeAttribute('autoplay');
      item.muted = true;
    });
    wrapper.appendChild(slide);
    var thumb = firstThumb.cloneNode(false);
    thumb.removeAttribute('data-variant-thumb');
    thumb.dataset.index = String(index);
    thumb.classList.remove('tw-border-navy');
    thumb.classList.add('tw-border-transparent');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    // Inline handler survives section HTML serialization as well as DOM swaps.
    thumb.setAttribute('onclick', 'galleryGoTo(' + JSON.stringify(root.id) + ', ' + index + ')');
    var preview = document.createElement('img');
    var image = slide.querySelector('img');
    preview.src = video ? video.poster : image.src;
    preview.alt = video ? 'Installation video' : image.alt;
    preview.className = 'tw-w-full tw-h-full tw-object-cover';
    preview.loading = 'lazy';
    thumb.appendChild(preview);
    rail.appendChild(thumb);
  });
};

// Shopify replaces section HTML without executing its inline application script.
// Register each section's existing app factory so editor changes get live controls.
window.pdpEditorMounts = window.pdpEditorMounts || new Map();
if (!window.pdpEditorLoadBound) {
  window.pdpEditorLoadBound = true;
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var root = target && target.querySelector && target.querySelector('product-info[data-section]');
    if (!root) return;
    var mount = window.pdpEditorMounts.get(root.dataset.section);
    if (mount) mount(root);
  });
}
